import React, { useState, useEffect } from 'react'
import NavBar from '../../Components/NavBar'
import AsideLeftHome from '../../Components/AsideLeftHome'
import Footer from '../../Components/Footer'
import { useParams } from 'react-router'
import api from '../../lib/api'
import localImages from '../../lib/localImages'
import "./style.scss"
import moment from 'moment'
export default function PostDetail(props) {

	//este codigo hace que no se rompa la navBar en la vista del post XD
	const [search, setSearch] = useState("")
	function getSearch(value) {
		setSearch(value)
	}
	//plese no me lo borres alfred =(
	const userInfo = localStorage.getItem('user-info') && JSON.parse(localStorage.getItem('user-info'))
	const [temporalComment, setTemporalComment] = useState();
	const { postId } = useParams();
	const [post, setPost] = useState({})
	useEffect(async () => {
		let response = await api.getPostById(postId);
		response.data.post.comments = response.data.post.comments.sort(function (left, right) {
			return moment.utc(right.published_timestamp).diff(moment.utc(left.published_timestamp))
		});
		setPost(response.data.post)
	}, [])

	async function addComment (postId,comment){
		const response = await api.createComment(postId,comment);
		response.data.post.comments = response.data.post.comments.sort(function (left, right) {
			return moment.utc(right.published_timestamp).diff(moment.utc(left.published_timestamp))
		});
		setPost(response.data.post)
	}
	function buttonHandler(event){
		if(event.target.value !== ""){
			const userId = userInfo.id;
			const date = new Date()
			let publishedAt = date.toISOString()
			let readableDate = date.toDateString().split(" ").slice(1,3).join(" ")
			
			const comment = {
				content: temporalComment,
				user: userId,
				published_timestamp: publishedAt,
				readable_publish_date: readableDate
			}
			addComment(postId, comment)

		}
	}
	function handleEnterKey(event){
		if(event.key=="Enter"){
			if(event.target.value !== ""){
				const userId = userInfo.id;
				const date = new Date()
				let publishedAt = date.toISOString()
				let readableDate = date.toDateString().split(" ").slice(1,3).join(" ")
				
				const comment = {
					content: temporalComment,
					user: userId,
					published_timestamp: publishedAt,
					readable_publish_date: readableDate
				}
				addComment(postId, comment)

			}
		}
		setTemporalComment(event.target.value)
	}
	async function reactionHandler(event){
		if(userInfo){
			const response = await api.updateReactionByPostId(postId,userInfo.id);
			setPost(response.data.post)
		}
	}
	return (
		<>
			<NavBar getSearch={getSearch} />


			{/*--------------------------------------------------------------------------------------MAIN-----------------------------------------------------------------*/}
			<body>
				<main className="container-xl custom-container">

					<div class="row">
						{/*-------------------------------------------------------------------ASIDE LEFT-------------------------------------------------------------------------------------*/}
						<aside class="col-12 col-md-1">
							<div class="post-detail-actions">
								<button className={`action heart ${userInfo &&  post.reactions && post.reactions.indexOf(userInfo.id) !== -1 ? "active" : ""}`} id="reactions-btn" onClick={reactionHandler}>
									<span class="icon">
										<img src={localImages.likes} alt="like" />
									</span>
									<span class="counter" id="reactions-count">{
										post.reactions_count ? post.reactions_count : 0
									}</span>
								</button>
								<button class="action unicorn">
									<span class="icon">
										<img src={localImages.unicorn} alt="unicorn" />
									</span>
									<span class="counter">500</span>
								</button>
								<button class="action save">
									<span class="icon">
										<img src={localImages.save} alt="save" />
									</span>
									<span class="counter">60</span>
								</button>
								<button class="action more">
									<span class="icon">
										<img src={localImages.dots} alt="like" />
									</span>
								</button>
							</div>

						</aside>
						{/*------------------------------------------------------------------------CARDS--------------------------------------------------------------------------*/}
						<section class="col-12 col-md-11 col-lg-8 post-detail">
							<div class="card">
								<img src={post.cover_image} class="card-img-top"
									alt="" id="cover-image" />
								<div class="card-body">
									<h1 class="card-text font-weight-bold" id="title" name="title">{post.title}</h1>
								</div>
								<div class="pl-4" id="tags-list">
									{
										post.tag_list && post.tag_list.map(item => {
											return <button class="btn-card-2 text mr-2" type="button">#{item}</button>
										})
									}
								</div>
								<div class="card-format pt-3 pl-4">
									<img class="img-yash mr-2 mt-3" src={
										post.user &&
											post.user.profile_picture ? post.user.profile_picture : "https://avatars.dicebear.com/api/male/john.svg"
									}
										alt="yash tiwari" id="user-image" />
									<span id="user-name">
										{
											post.user &&
											post.user.name
										}</span>
									<span class="date-txt" id="post-date">{post.readable_publish_date && post.readable_publish_date}</span>
									<span class="date-txt" id="read-time">7</span>
									<span class="date-txt">min read</span>
									<div class="card-text">
										<p class="card-txt-2 mt-3" id="content" name="content">
											{post.content && post.content}
										</p>
									</div>
									<div class="d-none">
										<h4 class="font-weight-bold">Discussions (1)</h4>
										<form>
											<img class="img-discussion" src="images/pics/sick.jpg"
												alt="xochitl" />
											<textarea name="" id="" cols="50" rows="10"
												placeholder="Add to the discussion."></textarea>
											<div class="invalid-feedback">
												Please provide a valid city.
											</div>
										</form>


										<div>
											<img class="img-discussion" src="images/pics/karen.jpeg"
												alt="karen" />
										</div>
									</div>
								</div>
							</div>

							{/*-- Discussion section --*/}

							<article class="discussion-section pl-3 pr-3 pt-3 pb-3 mt-5 pl-m-4 pr-m-4 pl-xl-5 pr-xl-5 bg-white rounded">
								<div class="discussion-title-button d-flex justify-content-between">
									<h2>Discussion (<span class="comments-qty">1</span>)</h2>
									<button type="button" class="btn btn-outline-secondary subscribe">Subscribe</button>
								</div>
								{
									userInfo &&
									<div class="discussion-comment-box d-flex mt-3">
										<img class="rounded-circle mr-2" width="24px" height="24px" src="https://res.cloudinary.com/practicaldev/image/fetch/s--IjCb_ILa--/c_fill,f_auto,fl_progressive,h_90,q_auto,w_90/https://dev-to-uploads.s3.amazonaws.com/uploads/user/profile_image/647885/81bdd7eb-d4eb-4f9e-94a3-0ce06183465b.png" alt="chava" />
										<form class="comment-form">
											<div class="input-group">
												<textarea class="form-control" placeholder="Add to the discussion" id="comment-input" onKeyUp={handleEnterKey}></textarea>
												<div class="invalid-feedback">
													Huh? You didn't enter text, please do it!
												</div>
												<div class="valid-feedback">
													Thanks for your comment!
												</div>
											</div>
											<div class="mt-2">
												<button class="btn btn-primary btn-submit rounded mr-3" type="button" id="add-comment-btn" onClick={buttonHandler}><b>Submit</b></button>
												<button class="btn btn-secondary rounded" type="button"><b>Preview</b></button>
											</div>
										</form>
									</div>
								}

								<div class="comment-container">
									{	
										post.comments &&
										post.comments.map(
											({profile_picture, name, readable_publish_date, content },index) => {
											return <div class="comment-box pt-3 d-flex" key= {index}>
												<div class="pfp-collapse-images pr-md-0 d-flex mr-2 flex-column">
													<img class="rounded-circle" width="24px" height="24px" src={ profile_picture ? profile_picture : "https://res.cloudinary.com/practicaldev/image/fetch/s--IjCb_ILa--/c_fill,f_auto,fl_progressive,h_90,q_auto,w_90/https://dev-to-uploads.s3.amazonaws.com/uploads/user/profile_image/647885/81bdd7eb-d4eb-4f9e-94a3-0ce06183465b.png"} alt="karen" />
												</div>
												<div class="comment-info col-11 pl-md-0">
													<div class="card">
														<div class="card-body pt-1">
															<div class="comment-person-info d-flex">
																<p class="card-text"><small class="text-muted"> <b>{ name}</b></small></p>
																<p class="card-text pl-1"><small class="text-muted">{readable_publish_date}</small></p>
															</div>
															<p>
																{ content}
															</p>
														</div>
													</div>
													<div class="comment-interaction">
														<button type="button" class="btn btn-light bg-white"><img src={ localImages.heart } alt="heart" /> <span class="font-weight-normal" >0</span> likes</button>
														<button type="button" class="btn btn-light bg-white"><img src={ localImages.comments } alt="comment" />0</button>
													</div>
												</div>
											</div>
										})
									}
								</div>
								<button class="save mt-3 ml-4 d-none" id="toogle-show-comments">Show all <span class="comments-qty"></span> comments</button>
							</article>

							{/*---------------------------------------------------------------2nd DIV TOÑO--------------------------------------------------------------------------------*/}
							<div class="card mt-3 bg-post p-2">
								<h3 class="p-3 mt-2 title">Read next</h3>
								<div class="d-flex c-header mt-3">
									<div class="ml-3 mb-3">
										<img src="images/pics/alfred.jpg" alt="" class="pt-card" />
									</div>
									<div class="d-flex c-name ml-2">
										<a href="#" class="ps-list">
											<h5>Don´t use Singleton Pattern in your unit
												tests</h5>
										</a>
										<p>Alfredo Pizana - June 10</p>
									</div>
								</div>
								<div class="d-flex c-header mt-3">
									<div class="ml-3 mb-3">
										<img src="images/pics/karen.jpeg" alt="" class="pt-card" />
									</div>
									<div class="d-flex c-name ml-2">
										<a href="#" class="ps-list">
											<h5>I have no idea what i´m doing</h5>
										</a>
										<p>Silvia Snow - June 9</p>
									</div>
								</div>
								<div class="d-flex c-header mt-3">
									<div class="ml-3 mb-3">
										<img src="images/pics/me and michael.jpg" alt=""
											class="pt-card" />
									</div>
									<div class="d-flex c-name ml-2">
										<a href="#" class="ps-list">
											<h5>I hope get to finish kodemia´s bootcamp</h5>
										</a>
										<p>Antonio Ibarra - Jun 5</p>
									</div>
								</div>
								<div class="d-flex c-header mt-3">
									<div class="ml-3 mb-3">
										<img src="images/pics/sick.jpg" alt="" class="pt-card" />
									</div>
									<div class="d-flex c-name ml-2">
										<a href="#" class="ps-list">
											<h5>What's the difference between var, let and
												const keywords?</h5>
										</a>
										<p>Xochitl Moreno - May 30</p>
									</div>
								</div>

							</div>
						</section>
						{/*------------------------------------------------------------------ ASIDE RIGHT----------------------------------------------------------------------*/}
						<aside class="d-none d-lg-block d-xl-block col-lg-3 col-xl-3">
							<div class=" sticky-top post-detail-profile">
								<div class="card box post-detail-profile-info">
									<div class="card-header">
										<img class="img-size" src={
										post.user &&
											post.user.profile_picture ? post.user.profile_picture : "https://avatars.dicebear.com/api/male/john.svg"
									}
											alt="Israel Salinas" />
										<h5 class="card-title">{
											post.user &&
											post.user.name
										}</h5>
									</div>
									<div class="card-body">

										<p class="card-text">Making the best platform for all developers
											--<br />http://thesmartcoder.dev
											<img class="laptop-icon" src={localImages.videos}
												alt="" /> <br />Programming is the best
											job in the
											world! Coder
											<img class="laptop-icon"
												src={localImages.podcasts}
												alt="laptop-icon" />
											Multimedia
											<img class="laptop-icon"
												src={localImages.codeofconduct}
												alt="laptop-icon" /><br />Building an Empire
										</p>
										<button class="follow-btn" type="button">Follow</button>
										<ul class="list-style">
											<li><b class="simon-txt">WORK</b><br />Maker <span
												class="card-span">at</span> The Smart
												Coder</li>
											<li><b class="simon-txt">LOCATION</b><br />Remote</li>
											<li><b class="simon-txt">JOINED</b><br />Jul 29, 2019</li>
										</ul>
									</div>
								</div>
								{/*----------------------------------------------------------------MORE FROM ISRAEL SALINAS---------------------------------------------------------*/}
								<div class="card mt-3">
									<div class="card-header font-weight-bold">
										<h5>More from <span class="c-text-color">Israel Salinas</span>
										</h5>
									</div>
									<ul class="list-group list-group-flush">
										<li class="list-group-item">Lesser-Known Yet Still Popular Java
											Script Frameworks for
											Front-End Developers<span
												class="card-txt"><br />#javascript #webdev
												#beginners</span>
										</li>
										<li class="list-group-item">10 Awesome Free Courses for Devs by
											Devs<span class="card-txt"><br />#javascript #webdev
												#react #vue</span></li>
										<li class="list-group-item">Java vs. JavaScript - What is the
											Difference?<span class="card-txt"><br />#javascript #java
												#webdev<br />#todayilearned</span></li>
									</ul>
								</div>
							</div>

						</aside>
					</div>

				</main>
			</body>

			{/*--------------------------------------------------------------------------FOOTER---------------------------------------------------------------------------*/}
			<Footer />
		</>

	)
}
